import { createAsyncThunk } from "@reduxjs/toolkit";
import { ProfessionnelService } from "../../../core/services/professionnel.service";
import { ProfessionnelReduitDelegant, TypeSollicitation, UserInfo } from "../../../core/apis/monsisra/generated";
import { User } from "./auth.types";
import { StoreState } from "../index";
import { getPreferences, getTypesFormulaire } from "../expertise/expertise.action";

const service = new ProfessionnelService();

export type setUserSelectedReturn = {
	selected: User;
};
export const setUserSelected = createAsyncThunk(
	"auth/setUserSelected",
	async (selected: User["idTechPs"], { getState, dispatch }): Promise<setUserSelectedReturn> => {
		const { auth } = getState() as StoreState;

		if (auth.isAdminMode) {
			const idTechPsCibleIframe = await service.getInfosPs(selected);
			const usr = extractUser(idTechPsCibleIframe);
			await dispatch(getPreferences(usr.idTechPs));

			return { selected: usr };
		}

		await dispatch(getPreferences(selected));
		return {
			selected: auth.delegants.find((user: User) => user.idTechPs === selected)!,
		};
	}
);

function extractLibelle(user: UserInfo) {
	let str = "";
	if (user.civilite) str += `${user.civilite} `;
	return `${str} ${user.prenom} ${user.nomUsuel?.toUpperCase()}`;
}

function extractUser(user: UserInfo): User {
	return {
		libelle: extractLibelle(user),
		idTechPs: user.idTechPSConnecte!,
		idNatPs: user.idCarte,
	};
}

function extractUserFromDelegant(delegant: ProfessionnelReduitDelegant): User {
	return {
		libelle: delegant.libelle!,
		idTechPs: delegant.idTechPs!,
		idNatPs: delegant.rppsOrIdCarteOrAdeli,
	};
}

export const getInitialUserAndAppInfos = createAsyncThunk(
	"auth/getInitialUserAndAppInfos",
	async (idTechPSAuthentifie: string, { dispatch, getState }): Promise<User[]> => {
		const {
			expertise: { type },
		} = getState() as StoreState;

		console.log(`Retrieving app infos for user '${idTechPSAuthentifie}'`);

		const self = await service.getPs();

		let delegants = self.listeDelegants!.filter((ps) => ps.idTechPs !== self.idTechPSConnecte);

		dispatch(getTypesFormulaire());

		let usr = extractUser(self);
		if (type === TypeSollicitation.DemandeAppui) {
			delegants = delegants.filter((d) => d.estMorale);
			const [firstDelegant] = delegants;
			if (firstDelegant && firstDelegant.idTechPs) {
				await dispatch(setUserSelected(firstDelegant.idTechPs));
			}
			return delegants.map(extractUserFromDelegant);
		} else {
			await dispatch(setUserSelected(self.idTechPSConnecte!));
			return [usr, ...delegants.map(extractUserFromDelegant)];
		}
	}
);

type verifyAndSelectUserParams = {
	idTechPsCible: string;
	parentUrl: string;
};
export const verifyAndSelectUser = createAsyncThunk(
	"auth/verifyAndSelectUser",
	async ({ idTechPsCible, parentUrl }: verifyAndSelectUserParams, { dispatch }) => {
		await dispatch(verifyAdminAccess({ idTechPsCible, parentUrl }));
		await dispatch(setUserSelected(idTechPsCible));
	}
);

type verifyAdminAccessParams = {
	idTechPsCible: string;
	parentUrl: string;
};
export const verifyAdminAccess = createAsyncThunk(
	"auth/verifyAdminAccess",
	async ({  idTechPsCible, parentUrl }: verifyAdminAccessParams): Promise<boolean> => {
		return await service.getDroitOuvrirIframeTleModeAdmin(idTechPsCible, parentUrl);
	}
);